'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var CASE_SPLIT_PATTERN = RegExp("\\p{Lu}?\\p{Ll}+|[0-9]+|\\p{Lu}+(?!\\p{Ll})|\\p{Emoji_Presentation}|\\p{Extended_Pictographic}|\\p{L}+", "gu");
function words(str) {
    var _str_match;
    return Array.from((_str_match = str.match(CASE_SPLIT_PATTERN)) !== null && _str_match !== void 0 ? _str_match : []);
}
exports.CASE_SPLIT_PATTERN = CASE_SPLIT_PATTERN;
exports.words = words;
